import { Search, RotateCcw, MapPin, CalendarDays } from "lucide-react";
import { LOCAL_STATUSES } from "../ui/orderStatuses";

const fieldClass =
  "w-full rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm text-slate-900 dark:text-slate-100 px-3 py-2";

export function FiltersBar({ filters, onChange, onReset, city = [], statuses }) {
  const statusOptions = statuses || Object.keys(LOCAL_STATUSES);

  return (
    <div className="toolbar-card rounded-xl border border-slate-200 bg-white p-3 dark:border-slate-800 dark:bg-slate-900">
      <div className="grid grid-cols-1 gap-2 md:grid-cols-12">
        <label className="relative md:col-span-4">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input
            placeholder="Client, téléphone ou produit…"
            value={filters.search || ""}
            onChange={(e) => onChange({ search: e.target.value })}
            className={`${fieldClass} pl-9`}
          />
        </label>

        <label className="relative md:col-span-2">
          <MapPin className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <select
            value={filters.city || ""}
            onChange={(e) => onChange({ city: e.target.value })}
            className={`${fieldClass} pl-9`}
          >
            <option value="">Toutes les villes</option>
            {city.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </label>

        <select
          value={filters.local_status || ""}
          onChange={(e) => onChange({ local_status: e.target.value })}
          className={`${fieldClass} md:col-span-2`}
        >
          <option value="">Tous les statuts</option>
          {statusOptions.map((value) => (
            <option key={value} value={value}>
              {LOCAL_STATUSES[value]?.label || value}
            </option>
          ))}
        </select>

        <div className="flex items-center gap-2 md:col-span-3">
          <CalendarDays className="hidden h-4 w-4 shrink-0 text-slate-400 md:block" />
          <input
            type="date"
            value={filters.date_from || ""}
            onChange={(e) => onChange({ date_from: e.target.value })}
            className={fieldClass}
            aria-label="Du"
          />
          <input
            type="date"
            value={filters.date_to || ""}
            onChange={(e) => onChange({ date_to: e.target.value })}
            className={fieldClass}
            aria-label="Au"
          />
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center justify-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800 md:col-span-1"
          title="Réinitialiser les filtres"
        >
          <RotateCcw className="h-4 w-4" />
          <span className="md:hidden xl:inline">Reset</span>
        </button>
      </div>
    </div>
  );
}
